export default function useLayout(Component: any) {
  const getLayout = Component.getLayout || ((page: any) => page);
  return { getLayout };
}
